import { Checkbox, Col, Image, Row, Tabs, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { LabelDiv } from "./detailFields";
import ProfileInput from "./detailFields";
import { IMG_URL } from "../../env.json";
import { CgFileDocument } from "react-icons/cg";
import { Button } from "components/Button";
import {
  CameraFilled,
  EyeOutlined,
  EyeInvisibleOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
} from "@ant-design/icons";
import EditProfilePic from "./editProfilePic";
import DeletePicConfirmationModal from "./deletePicConfirmationModal";
import TabPane from "antd/lib/tabs/TabPane";
import { splitText } from "./accountDetails";
import { Notification } from "services";
import styled from "styled-components";

const BlueCheckboxWrapper = styled.span`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #1089ff !important;
    border-color: #1089ff !important;
  }
  .ant-checkbox-checked::after {
    border-color: #1089ff !important;
  }
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #1089ff !important;
  }
`;

const DetailField = ({ field, index, userProfileDetails }) => {
  console.log(
    "userProfileDetails-16",
    userProfileDetails?.privilage?.includes("SuperAdmin")
  );

  return field ? (
    <Col
      key={index}
      md={{ span: field.space === 0.5 ? 12 : 24 }}
      lg={{ span: field.space === 0.5 ? 6 : 12 }}
      style={{ width: "100%", ...field.style }}
    >
      <div style={{ width: "95%" }}>
        {field.type === "bullet" ? (
          <>
            <LabelDiv>
              {field.label}
              {field.required && <span style={{ color: "red" }}> *</span>}
            </LabelDiv>
            <ul className="display-flex">
              {field.value?.map((item, index) => (
                <li key={index} className="m-r-20">
                  {splitText(item)}
                </li>
              ))}
            </ul>
          </>
        ) : field?.type == "Checkbox" ? (
          <>
            {console.log(field, "field value")}
            <LabelDiv>
              {field.label}
              {field.required && <span style={{ color: "red" }}> *</span>}
            </LabelDiv>
            {userProfileDetails?.privilage?.includes("SuperAdmin") ? (
              <div style={{ display: "flex", gap: 10 }}>
                <Checkbox checked={true} disabled />
                <div>Super admin</div>
              </div>
            ) : (
              <Checkbox.Group
                options={field?.value}
                value={field?.value
                  ?.filter((item) => item?.isSelected)
                  .map((item) => item?.value)}
                onChange={field.onChange}
              ></Checkbox.Group>
            )}
          </>
        ) : (
          <>
            {/* sits in the same column as the input, so it stays put whatever the grid does */}
            {field.checkboxAbove ? (
              <div style={{ marginBottom: 10 }}>
                <Checkbox
                  checked={!!field.checkboxAbove.checked}
                  disabled={field.checkboxAbove.disabled}
                  onChange={field.checkboxAbove.onChange}
                >
                  {field.checkboxAbove.label}
                </Checkbox>
              </div>
            ) : null}
          <ProfileInput
            label={field.label}
            type={field.type}
            disabled={field.disabled}
            required={field.required}
            value={field.value}
            onChange={(e) => (field?.onChange ? field.onChange(e) : {})}
            onSelect={(value) => {
              field.onSelect ? field.onSelect(value) : {};
            }}
            options={field.options}
            placeholder={field.placeholder}
            error={field.error}
            onFocusChange={field.onFocusChange}
            disabledDate={field?.disabledDate}
            phonInputWithSendOtp={field?.phonInputWithSendOtp}
          />
          </>
        )}
      </div>
    </Col>
  ) : null;
};

const DetailSection = ({
  section,
  index,
  userProfileDetails,
  fromAulasWallet,
}) => {

  return (
    <div key={index}>
      {fromAulasWallet ? (
        <></>
      ) : (
        <div className="r-jsb">
          <div>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 5 }}>
              {section.heading}
            </div>
            <div style={{ fontSize: 14, marginBottom: 20 }}>
              {section.subHeading}
            </div>
          </div>
          {section.checkbox ? (
            <div className="m-r-40">
              <BlueCheckboxWrapper>
                <Checkbox
                  checked={section.checkbox.value}
                  onChange={section.checkbox.action}
                  disabled={
                    userProfileDetails?.basicprofile?.currentAddress?.city ===
                      undefined ||
                    userProfileDetails?.basicprofile?.currentAddress?.city ===
                      "" ||
                    userProfileDetails?.basicprofile?.currentAddress?.country ===
                      undefined ||
                    userProfileDetails?.basicprofile?.currentAddress?.country ===
                      "" ||
                    userProfileDetails?.basicprofile?.currentAddress?.h_no ===
                      "" ||
                    userProfileDetails?.basicprofile?.currentAddress?.pincode ===
                      "" ||
                    userProfileDetails?.basicprofile?.currentAddress?.h_no ===
                      undefined ||
                    userProfileDetails?.basicprofile?.currentAddress?.pincode ===
                      undefined
                      ? true
                      : false
                  }
                />
              </BlueCheckboxWrapper>
              &nbsp; {section.checkbox.text}
            </div>
          ) : null}
        </div>
      )}
      <Row>
        {console.log("section.fields", userProfileDetails)}

        {section.fields.map((field, index) => (
          <DetailField
            field={field}
            index={index}
            userProfileDetails={userProfileDetails}
          />
        ))}
      </Row>
      {fromAulasWallet ? (
        <></>
      ) : (
        <div
          style={{
            width: "100%",
            borderBottom: "1px solid #E6E6E6",
            marginBottom: 20,
            marginTop: 20,
          }}
        />
      )}
    </div>
  );
};

const getNameInitials = (name) => {
  if (!name) return "";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const ImageComponent = React.forwardRef(
  (
    {
      userProfileDetails,
      src,
      setfileInputValue,
      handleEditModal,
      editable = true,
      fromLoginRegisterForm,
      imageRemove,
      defaultImg,
    },
    ref
  ) => {
    const [imgUrl, setImgUrl] = useState("");
    const [showFileFromLocal, setShowFileFromLocal] = useState(false);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [scale, setScale] = useState(1);
    const [rotate, setRotate] = useState(0);

    useEffect(() => {
      setShowFileFromLocal(false);
    }, [src]);

    useEffect(() => {
      if (!previewVisible) {
        setScale(1);
        setRotate(0);
      }
    }, [previewVisible]);

    const onChangeFile = (e) => {
      const file = e.target.files[0];
      if (file) {
        const allowedMimeTypes = ["image/jpeg", "image/png", "image/webp"];
        const fileExtension = file.name.split('.').pop().toLowerCase();
        const allowedExtensions = ["jpg", "jpeg", "png", "webp"];
        
        if (!allowedMimeTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
          Notification.error("Please upload a JPG, JPEG, PNG, WEBP image under 5MB.");
          e.target.value = "";
          return;
        }

        const maxFileSize = 5 * 1024 * 1024; // 5 MB
        if (file.size > maxFileSize) {
          Notification.error("Please upload a JPG, JPEG, PNG, WEBP image under 5MB.");
          e.target.value = "";
          return;
        }

        setfileInputValue(file);
        setImgUrl(URL.createObjectURL(file));
        setShowFileFromLocal(true);
      }
    };
    useEffect(() => {
      if (!imageRemove) {
        setShowFileFromLocal(false);
      }
    }, [imageRemove]);

    const imageUrlToUse = fromLoginRegisterForm
      ? (typeof src == "object" ? URL.createObjectURL(src) : src)
      : (userProfileDetails?.image == "default.png" &&
        (userProfileDetails?.file == "default.png" ||
          !userProfileDetails?.file)
          ? IMG_URL + "/" + "default.png"
          : !showFileFromLocal
          ? IMG_URL + "/" + src
          : imgUrl);

    const initials = getNameInitials(userProfileDetails?.name || "");
    const isDefaultImg = !src || src === "default.png" || src === "" || (typeof src === "string" && src.includes("awesome-user-alt"));
    const hasNoImage = isDefaultImg && !showFileFromLocal && initials !== "";
    const initialsSize = fromLoginRegisterForm ? 80 : 120;
    const initialsFontSize = fromLoginRegisterForm ? "24px" : "36px";
    const initialsBg = userProfileDetails?.backgroundColor ? `#${userProfileDetails.backgroundColor}` : '#DFDEF5';
    const initialsColor = userProfileDetails?.textColor ? `#${userProfileDetails.textColor}` : '#594099';

    return (
      <div className="r-c-c-c m-b-30 m-t-40">
        {hasNoImage ? (
          <div
            style={{
              width: initialsSize,
              height: initialsSize,
              borderRadius: "50%",
              backgroundColor: initialsBg,
              color: initialsColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: initialsFontSize,
              fontWeight: "600",
              textTransform: "uppercase"
            }}
          >
            {initials}
          </div>
        ) : fromLoginRegisterForm ? (
          <Image
            src={imageUrlToUse}
            alt=""
            width={80}
            height={80}
            style={{ borderRadius: 100, cursor: "pointer" }}
            preview={false}
            onClick={() => setPreviewVisible(true)}
          />
        ) : (
          <Image
            src={imageUrlToUse}
            alt=""
            width={120}
            height={120}
            style={{ borderRadius: 120, cursor: "pointer" }}
            preview={false}
            onClick={() => setPreviewVisible(true)}
            wrapperStyle={{ paddingTop: 4 }}
          />
        )}
        <input
          type="file"
          id="file"
          onChange={(e) => {
            onChangeFile(e);
          }}
          ref={ref}
          style={{ display: "none" }}
          accept="image/*"
          value=""
        />

        {editable ? (
          <div
            className="box-shadow cursor-pointer"
            style={{
              position: "relative",
              bottom: 36,
              right: -50,
              fontSize: 18,
              background: "white",
              padding: "5px 10px",
              borderRadius: 20,
            }}
            onClick={() => handleEditModal(true)}
          >
            <CameraFilled />
          </div>
        ) : null}

        {previewVisible && (
          <div 
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0,0,0,0.65)',
              zIndex: 100000,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onClick={() => setPreviewVisible(false)}
          >
            <div 
              style={{ 
                position: 'relative', 
                display: 'inline-block',
                backgroundColor: '#fff',
                padding: 5,
                borderRadius: 4
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ overflow: 'hidden', borderRadius: 4 }}>
                <img 
                  src={imageUrlToUse} 
                  alt="Preview" 
                  style={{ 
                    maxWidth: '85vw', 
                    maxHeight: '85vh', 
                    display: 'block',
                    transform: `scale(${scale}) rotate(${rotate}deg)`,
                    transition: 'transform 0.2s ease-in-out'
                  }} 
                />
              </div>
              <div 
                style={{
                  position: 'absolute',
                  top: 12,
                  right: 12,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 8,
                  zIndex: 100001
                }}
              >
                <div 
                  onClick={() => setPreviewVisible(false)}
                  style={{
                    cursor: 'pointer',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.65)',
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 14,
                    fontWeight: 'bold',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.25)'
                  }}
                >
                  ✕
                </div>
                <div 
                  onClick={() => setScale(prev => prev + 0.25)}
                  style={{
                    cursor: 'pointer',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.65)',
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 16,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.25)'
                  }}
                >
                  <ZoomInOutlined />
                </div>
                <div 
                  onClick={() => setScale(prev => Math.max(0.25, prev - 0.25))}
                  style={{
                    cursor: 'pointer',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.65)',
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 16,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.25)'
                  }}
                >
                  <ZoomOutOutlined />
                </div>
                <div 
                  onClick={() => setRotate(prev => prev - 90)}
                  style={{
                    cursor: 'pointer',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.65)',
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 16,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.25)'
                  }}
                >
                  <RotateLeftOutlined />
                </div>
                <div 
                  onClick={() => setRotate(prev => prev + 90)}
                  style={{
                    cursor: 'pointer',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.65)',
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 16,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.25)'
                  }}
                >
                  <RotateRightOutlined />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
);

// same colours as the KYC form's document status tags
const docStatusColors = { approved: "#427a09", rejected: "#FF414D", pending: "#f5a623" };

const IndividualDetails = ({ data, index, span, type = "text" }) => {
  console.log({ data });

  const [isViewEnabled, setIsViewEnabled] = useState(data?.onView);

  const toggleView = () => {
    setIsViewEnabled((prevIsViewEnabled) => !prevIsViewEnabled);
    data?.onView();
  };

  const displayValue = (data?.value !== undefined && data?.value !== null && data?.value !== "") ? data.value : "N/A";

  return data ? (
    <Col span={span || 12} key={index} style={{ marginTop: 24, width: "100%" }}>
      <div className="r-jsb" style={{ width: data.type === "document" ? "95%" : undefined }}>
        <div style={{ size: 12, color: "#636363" }}>{data.label}</div>
        {data.type === "document" && data.status ? (
          <div style={{ padding: "1px 10px", borderRadius: 30, backgroundColor: docStatusColors[data.status], color: "white", fontSize: 9, fontWeight: 600, marginBottom: 5, alignSelf: "center" }}>
            {data.status.toUpperCase()}
          </div>
        ) : null}
      </div>
      {data.type !== "document" ? (
        <div className="r-jsb">
          <div
            style={{
              fontFamily: "roboto",
              fontSize: 16,
              width: "95%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            <Tooltip title={displayValue}>{displayValue} </Tooltip>
          </div>
          {data.hidden ? (
            <>
              {isViewEnabled ? (
                <EyeOutlined
                  className="m-r-10 cursor-pointer"
                  onClick={toggleView}
                />
              ) : (
                <EyeInvisibleOutlined
                  className="m-r-10 cursor-pointer"
                  onClick={toggleView}
                />
              )}
            </>
          ) : null}
        </div>
      ) : (
        <div
          style={{
            backgroundColor: "#E6E6E6",
            height: 92,
            width: "95%",
            alignItems: "center",
            padding: 24,
          }}
          className="r-jsb"
        >
          <div className="r-c-c">
            <CgFileDocument style={{ fontSize: 24, color: "#1089FF" }} />
            <div className="m-l-10">
              <div style={{ fontWeight: 600 }}>
                Document.{data.value?.split(".")[1]}
              </div>
            </div>
          </div>
          <div>
            <Button type="link" style={{ fontSize: 14 }}>
              <a href={IMG_URL + "/" + data.value} target="_blank">
                VIEW
              </a>{" "}
            </Button>
          </div>
        </div>
      )}
    </Col>
  ) : null;
};

const EditImage = ({
  editModalVisible,
  handleEditOk,
  onEditCancel,
  setEditProfileModal,
  setdeleteConfirmation,
  fromUserProfile,
  setProfileDetails,
  deleteConfirm,
  deleteModalVisible,
  onDeleteCancel,
  onDeleteConfirm,
  imageUrl,
  localImg,
  addUserFieldsData,
  userProfileDetails, type,
}) => {
  return (
    <>
      <EditProfilePic
        imageUrl={imageUrl}
        localImg={localImg}
        // userDetailsSaved={userDetailsSaved}
        // deletePicLoader={deletePicLoader}
        isModalVisible={editModalVisible}
        // handleCancel={handleCancel}
        // userDetailsById={userDetailsById}
        handleOk={handleEditOk}
        handleProfileModalCancel={onEditCancel}
        setdeleteConfirmation={deleteConfirm}
        userProfileDetails={userProfileDetails}
        type={type}
      />
      <DeletePicConfirmationModal
        isModalVisible={deleteModalVisible}
        handleCancel={onDeleteCancel}
        onDeleteConfirm={onDeleteConfirm}
        setEditProfileModal={setEditProfileModal}
        setdeleteConfirmation={setdeleteConfirmation}
        addUserFieldsData={addUserFieldsData}
        fromUserProfile={fromUserProfile}
        setProfileDetails={setProfileDetails}
        userProfileDetails={userProfileDetails}
        type={type}
      />
    </>
  );
};

const TabsComponent = ({
  handleTabSelect,
  selectedTab,
  instituteProfile,
  updateSettings,
  tabs,
}) => {
  return (
    <Tabs onChange={handleTabSelect} activeKey={selectedTab}>
      {Object.keys(tabs).map((tab, index) => (
        <TabPane tab={tab} key={tab}>
          {tabs[tab].body}
        </TabPane>
      ))}
    </Tabs>
  );
};

const easySwitch = (
  history,
  user,
  setGsSelectedTab,
  setSubscriptionSelectedTab,
  setOthersSelectedTab
) => {
  const easySwitchOptions = [
    {
      label: "General settings",
      path: "/general-settings",
      action: () => {
        history.push({
          state: { from: window.location.pathname },
          pathname: "/general-settings",
        });
        if (
          user.privilage.includes("Admin") ||
          user.privilage.includes("SuperAdmin")
        ) {
          setGsSelectedTab("User management");
        } else if (user.privilage.includes("FeeManager")) {
          setGsSelectedTab("Fee management");
        } else if (user.privilage.includes("LeaveManager")) {
          setGsSelectedTab("Attendance");
        } else {
          setGsSelectedTab("Attendance reminder");
        }
      },
    },
  ];
  if (user?.access?.includes("subscription-settings")) {
    easySwitchOptions.push({
      label: "Subscriptions/ Plans",
      path: "/subscriptions",
      action: () => {
        history.push({
          state: { from: window.location.pathname },
          pathname: "/subscriptions",
        });
        if (
          user.privilage.includes("Admin") ||
          user.privilage.includes("SuperAdmin")
        ) {
          setSubscriptionSelectedTab("aulas Plan");
        } else if (user?.role?.includes("Data Operator")) {
          setSubscriptionSelectedTab("Storage");
        } else if (user.privilage.includes("Planner")) {
          setSubscriptionSelectedTab("Broadcast");
        }
      },
    });
  }
  if (user?.access?.includes("fees")) {
    easySwitchOptions.push({
      label: "KYC details",
      path: "/view-kyc",
      action: () =>
        history.push({
          state: { from: window.location.pathname },
          pathname: "/view-kyc",
        }),
    });
  }
  if (user.access.includes("support-settings")) {
    easySwitchOptions.push({
      label: "aulas care support",
      path: "/support-settings",
      action: () =>
        history.push({
          state: { from: window.location.pathname },
          pathname: "/support-settings",
        }),
    });
  }
  if (user.role.includes("Student")) {
    easySwitchOptions.push({
      label: "Others",
      path: "/user-profile/others",
      action: () => {
        history.push({
          state: { from: window.location.pathname },
          pathname: "/user-profile/others",
        });
        setOthersSelectedTab("Classroom & course(s)");
      },
    });
  }
  return easySwitchOptions;
};

export {
  DetailField,
  DetailSection,
  ImageComponent,
  IndividualDetails,
  EditImage,
  TabsComponent,
  easySwitch,
};
